import React from "react";
import {UnCodeService} from "../../../services/unCodeService";
import Dictionary from "../../dictionary/dictionary";
import {UnCodeModel, UnCodeStatusModel} from "../../../models/unCode";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {routingAddresses} from "../../../../helpers/routing";
import {Chip} from "@mui/material";
import "./unCodesList.scss";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {SortDirection} from "../../../../common/models/table";
import SearchButton from "../../../../common/components/shared/searchButton/searchButton";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import {NavLink} from "react-router-dom";
import Button from "../../../../common/components/shared/button/button";

export default class UnCodesList extends Dictionary<UnCodeModel> {
    private sortableElements = ["status", "code", "name", "imdgClass"];

    constructor(props: any) {
        super(props);

        this.canRemove = true;
        this.linkToModify = routingAddresses.dictionaries.unCodes.modify;
    }

    public async componentDidMount() {
        this.getData(await this.getAll());
    }

    public render(): JSX.Element {
        const properties=["status", "code", "name", "imdgClass"];
        const headers = properties.map(key => i18n.t("dictionaries.unCodes.headers." + key));
        const actions = this.renderActions;
        return (
            <div className="un-codes">
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
                {this.renderWrapperContent(headers, properties, "un-codes", actions, this.renderCell, this.getHeader(), this.sortableElements, this.sortingAction.bind(this))}
            </div>
        );
    }

    protected async confirmRemove() {
        this.setState({removeItemResponse: undefined, isWaiting: true});

        const response = await UnCodeService.removeUnCode(this.state.selectedElement!.id);

        this.setState({removeItemResponse: response});

        if (Api.isSuccess(response)) {
            await this.getData(await this.getAll());
            this.setState({selectedElement: undefined, displayRemovePopup: false});
        } else {
            this.setState({errorMessage: i18n.t("dictionaries.unCodes.errors.removeErrorSuffix")});
        }
        this.setState({isWaiting: false});
    }

    private renderCell(row: any, property: string): JSX.Element {
        if (property === "status") {
            return <Chip className={row[property] == UnCodeStatusModel.ACTIVE ? "active" : "inactive"} label={i18n.t(`activeStatus.${row[property]}`)}/>;
        }
        return row[property];
    }

    private getHeader() {
        return (
            <>
                <div className="filters">
                    <TextInput
                        className="search-input"
                        label={i18n.t("dictionaries.unCodes.headers.name")}
                        validatedValue={this.state.selectedValue}
                        testId="filters-name"
                    />
                    <TextInput
                        className="search-input"
                        label={i18n.t("dictionaries.unCodes.headers.code")}
                        validatedValue={this.state.selectedTwoValue}
                        testId="filters-code"
                    />
                </div>
                <div className="actions">
                    <SearchButton
                        isWaiting={this.state.isWaiting}
                        onClick={async () => {
                            this.setState({isWaiting: true, dictionaryData: undefined});
                            await this.getData(await this.getAll());
                            this.setState({isWaiting: false});
                        }}
                    />
                    <NavLink to={routingAddresses.dictionaries.unCodes.add} data-testid="add-uncode">
                        <Button type="primary" text={i18n.t("dictionaries.unCodes.actions.addUnCode.button")}/>
                    </NavLink>
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId="un-code-list-reload-btn"
                    />
                </div>
            </>
        );
    }

    private async reload() {
        this.reloadList(await this.getAll());
    }

    private async sortingAction(orderBy: string, sortDirection: SortDirection) {
        await this.setState({orderBy, sortDirection});
        await this.reload();
    }

    private async getAll() {
        return await UnCodeService.getAll(
            {
                orderBy: this.state.orderBy,
                sortDirection: this.state.sortDirection
            },
            this.state.selectedValue.value.trim(),
            this.state.selectedTwoValue.value.trim()
        );
    }
}
